module.exports = __webpack_public_path__ + "img/order_none.c7f834dc.png";